import Reveal from '@/components/base/Reveal';
import { communityStats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section id="stats" className="bg-secondary-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-200 px-3 py-1 text-xs font-medium text-secondary-900">
            <span className="h-1.5 w-1.5 rounded-full bg-secondary-500" aria-hidden="true" />
            社区数据
          </span>
          <h2 className="mt-4 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            内容越积越多，分享还在继续
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            以下数据用来反映社区的更新节奏与内容体量，方便你判断这里是否值得长期关注。
          </p>
        </div>

        <dl className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {communityStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 70}>
              <div className="flex items-center gap-4 rounded-lg border border-secondary-200 bg-background-50 p-5">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-900">
                  <i className={`${stat.icon} text-xl`} aria-hidden="true" />
                </span>
                <div>
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                    {stat.value}
                  </dd>
                </div>
              </div>
            </Reveal>
          ))}
        </dl>
      </div>
    </section>
  );
}